
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useSystemStats } from "@/hooks/useSystemStats";
import { Users, Building, MapPin, Activity } from "lucide-react";
import { NACIcon } from "@/components/NACIcon";
import { Skeleton } from "@/components/ui/skeleton";

export function SystemOverview() {
  const { totalUsers, totalOrganizations, totalCities, totalAircraftTypes, totalFlights, loading, error } = useSystemStats();

  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>System Overview</CardTitle>
          <CardDescription>
            Quick stats and system information
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="text-center p-4 border rounded-lg">
                <Skeleton className="h-8 w-8 mx-auto mb-2" />
                <Skeleton className="h-8 w-12 mx-auto mb-2" />
                <Skeleton className="h-4 w-20 mx-auto" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  if (error) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>System Overview</CardTitle>
          <CardDescription>
            Quick stats and system information
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <p className="text-red-500">Error loading stats: {error}</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  const stats = [
    {
      label: "Total Users",
      value: totalUsers,
      icon: Users,
      color: "text-blue-500"
    },
    {
      label: "Organizations",
      value: totalOrganizations,
      icon: Building,
      color: "text-green-500"
    },
    {
      label: "Cities",
      value: totalCities,
      icon: MapPin,
      color: "text-orange-500"
    },
    {
      label: "Aircraft Types",
      value: totalAircraftTypes,
      icon: NACIcon,
      color: "text-purple-500"
    },
    {
      label: "Total Flights",
      value: totalFlights,
      icon: Activity,
      color: "text-red-500"
    }
  ];

  return (
    <Card>
      <CardHeader style={{ backgroundColor: 'orange' }}>
        <CardTitle>System Overview</CardTitle>
        <CardDescription>
          Quick stats and system information
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div key={index} className="text-center p-4 border rounded-lg hover:shadow-md transition-shadow">
                <IconComponent className={`h-8 w-8 mx-auto mb-2 ${stat.color}`} />
                <p className="text-2xl font-bold">{stat.value.toLocaleString()}</p>
                <p className="text-sm text-muted-foreground">{stat.label}</p>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
